// extracted by mini-css-extract-plugin
module.exports = {"container-border":"roi-calculator_container-border__nyYee"};